import React from 'react';
import { Modal, Typography } from 'antd';
import GridLayout from '../../../../shared/ui/GridLayout';
import ContentTitle from '../components/ContentTitle';
import ParentList from '../components/ParentList';
import ChildList from '../components/ChildList';
import { createHouseAddress } from '../../../../shared/packages/address';

const createTitle = (roomData) => {
  const isMultiple = Array.isArray(roomData);

  const address = createHouseAddress(isMultiple ? roomData[0] : roomData);

  if (isMultiple) {
    return `Исключаются все помещения по адресу ${address}. Весь дом исключится из приемки`;
  }

  return `Это последнее помещение по адресу ${address}. Весь дом исключится из приемки`;
};

export const createConfirm = ({
  onOk,
  parentRooms,
  childRooms,
  currentHouseId,
  roomData,
}) => {
  Modal.confirm({
    title: createTitle(roomData),
    content: (
      <Content
        parentRooms={parentRooms}
        childRooms={childRooms}
        currentHouseId={currentHouseId}
      />
    ),
    centered: true,
    onCancel: () => {},
    onOk,
  });
};

function Content({ parentRooms, childRooms, currentHouseId }) {
  const hasContent = parentRooms?.length > 0 || childRooms?.length > 0;

  return (
    <div>
      {hasContent && (
        <GridLayout>
          {Boolean(parentRooms?.length) && (
            <div>
              <ContentTitle>
                Помещения, к которым привязаны помещения других домов
              </ContentTitle>

              {parentRooms.map((room) => (
                <ParentList roomData={room} key={room.id} />
              ))}
            </div>
          )}

          {Boolean(childRooms?.length) && (
            <div>
              <ContentTitle>
                Помещения, которые привязаны к помещениям других домов
              </ContentTitle>

              {childRooms.map((room) => (
                <ChildList
                  key={room.id}
                  roomData={room}
                  currentHouseId={currentHouseId}
                />
              ))}
            </div>
          )}
        </GridLayout>
      )}
      <Typography.Paragraph>Продолжить?</Typography.Paragraph>
    </div>
  );
}
